import { render } from "./Balance.vue.js?vue&type=template&id=0cc7a8f2!=!../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.96.1/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Balance.vue?vue&type=template&id=0cc7a8f2"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__